const $screen = $(window).width();
const $height = $(window).height();


// Работоспособность зависит от глобальной переменной crb_mobile_logos!!!

const $baseUrl = `${window.location.origin}/wp-content/themes/tz2023/images/icons/menu/`

const $mobileNav =  $('header.mobile > nav.navbar')
const $menuMobile = $('#menu-mobile > img')
const $mobileWrapper = $('.mobile-menu-wrapper')

const mobileClosedMenu = '/menu.svg'
const mobileOpenedMenu = '/close.svg'


const changeIcons = () => {
  if($mobileNav.hasClass('opened')) {
    $menuMobile.attr('src', `${$baseUrl}${mobileOpenedMenu}` )
  } else {
    $menuMobile.attr('src', `${$baseUrl}${mobileClosedMenu}` )

  }
}

if (isMobilePlatform) {
  if($height <= 740) {
    $mobileWrapper.css('top', '97%')
  } else {
    $('.mobile-header .mobile-menu-wrapper').css('top', '54px')
  }

  $menuMobile.on('click', function () {
    $mobileNav.toggleClass('opened');
    $mobileWrapper.toggle()
    changeIcons();
    highlightMenuLink();
    if ( !$mobileNav.hasClass('opened') ) {
      $("html body").removeClass("overflow-hidden");
    } else {
      $("html body").addClass("overflow-hidden");
    }
  })

  $('.mobile-side-menu li').on('click', function () {
    $mobileNav.toggleClass('opened');
    $mobileWrapper.toggle()
    changeIcons();
    $("html body").removeClass("overflow-hidden");
  })

  $(".mobile-menu-bg-black").on('click', function () {
    $mobileNav.removeClass('opened');
    $mobileWrapper.hide()
    changeIcons();
    $("html body").removeClass("overflow-hidden");
  })

}

function highlightHeaderLink(target) {
	const curUrl = target ? target.find("a").attr("href") : window.location.href;
  $(".nav-item").removeClass("nav-item-active");
	
	$(".nav-item").each(function() {
    if (target != null) {
      if ( curUrl == $(this).find("a").attr("href") || $(this).find("a").attr("href").indexOf(curUrl) != -1 ) {      
        $(this).addClass("nav-item-active");
      }
    } else {
      if ( curUrl == $(this).find("a").attr("href") ) {      
        $(this).addClass("nav-item-active");
      }
    }
	});
}
$(".nav-item").on("click", function () {
  $(".nav-item").removeClass("nav-item-active");
  $(this).addClass("nav-item-active");
})
$(".desktop-side-menu__link").on("click", function () {
  highlightHeaderLink($(this));
})
$( document ).ready( function () {
  highlightHeaderLink();
});


function highlightMenuLink() {
	const curUrl = window.location.href;
	$(".desktop-side-menu__link").removeClass("menu-link-active");
	$(".mobile-side-menu__link").removeClass("menu-link-active");
  
	$(".desktop-side-menu__link").each(function(i) {
		if ( curUrl.indexOf($(this).find("a").attr("href")) != -1 ||  curUrl == $(this).find("a").attr("href") ) {    
			$($(".mobile-side-menu__link")[i]).addClass("menu-link-active");
			$(this).addClass("menu-link-active");
		}
	});
}
if (!isMobilePlatform) {
  $('#menu-desktop, .desktop-side-menu li').on('click', function () {
    $('.desktop-side-menu').toggle();
    highlightMenuLink();
  })
}
